import { useContext } from 'react';
import { NewMessageQueueContext } from '../contexts/messageQueueContext/messageQueueContext';

export const useMessageQueueContext = () => useContext(NewMessageQueueContext);
